import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Box, H5, P } from "orcs-design-system";
import { isEmpty } from "lodash";
import { useGoalsExploreContext } from "src/contexts/goalsExploreContext";
import TreeView from "src/shared/TreeView";
import ObjectiveTreeHeader from "./components/ObjectiveTreeHeader";

const GoalsExplore = () => {
  const { treeData, childrenMap, loading, error, loadBranch, loadingNodeIds } =
    useGoalsExploreContext();

  const onNodeSelected = useCallback(() => {
    // To be implemented
  }, []);

  const onNodeToggled = useCallback(
    (node) => {
      const nodeInfo = childrenMap[node.id];
      const needsToLoad =
        !nodeInfo || (!nodeInfo.fetched && !loadingNodeIds[node.id]);

      if (needsToLoad) {
        loadBranch(node.id);
      }
    },
    [loadBranch, loadingNodeIds, childrenMap]
  );

  const customizeTreeHeader = useCallback(
    (props) => {
      function CustomHeader({ node }) {
        return (
          <ObjectiveTreeHeader
            {...props}
            node={node}
            loadingNodeIds={loadingNodeIds}
          />
        );
      }
      CustomHeader.propTypes = {
        node: PropTypes.object.isRequired,
      };
      return CustomHeader;
    },
    [loadingNodeIds]
  );

  if (loading && isEmpty(treeData)) {
    return (
      <Box p="m">
        <P>Loading objectives...</P>
      </Box>
    );
  }

  if (error) {
    return (
      <Box p="m">
        <P color="danger">Error loading objectives: {error.message}</P>
      </Box>
    );
  }

  if (isEmpty(treeData)) {
    return (
      <Box p="m">
        <P>No objectives found</P>
      </Box>
    );
  }

  return (
    <Box>
      <H5 fontWeight="bold" mb="r">
        Goals
      </H5>
      <TreeView
        data={treeData}
        onNodeSelected={onNodeSelected}
        onNodeToggled={onNodeToggled}
        customizeTreeHeader={customizeTreeHeader}
        loadingNodeIds={loadingNodeIds}
      />
    </Box>
  );
};

export default GoalsExplore;
